import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, CollapseCard, Tooltip } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import * as React from 'react';
const OriginatingUrl = ({ url }) => (_jsx(Tooltip, Object.assign({ content: url, dark: true }, { children: _jsx("a", Object.assign({ target: "_blank", rel: "noopener noreferrer", href: url }, { children: url })) })));
const OriginatingCountryCode = ({ countryCode }) => (_jsx("span", { children: countryCode }));
export const UserTrackingCard = ({ isOpen: propIsOpen, isMinimized = false, attributes, onToggle, hasCollapseTrackingCard, }) => {
    const [localIsOpen, setLocalIsOpen] = useState(false);
    // We want this card to always start in a collapsed state if we have the feature flag:
    // https://dixa-product.atlassian.net/browse/TEAMS-4172
    const isOpen = hasCollapseTrackingCard ? localIsOpen : propIsOpen;
    const data = attributes !== null && attributes !== void 0 ? attributes : {};
    const items = [];
    if (data.ip_address) {
        items.push(['IP Address', data.ip_address]);
    }
    if (data.originating_country_code) {
        items.push([
            'Country',
            _jsx(OriginatingCountryCode, { countryCode: data.originating_country_code }, data.originating_country_code),
        ]);
    }
    if (data.originating_region) {
        items.push(['Region', data.originating_region]);
    }
    if (data.originating_city) {
        items.push(['City', data.originating_city]);
    }
    if (data.originating_url) {
        if (hasCollapseTrackingCard) {
            items.push(['Origin Url', data.originating_url]);
        }
        else {
            items.push([
                'Origin Url',
                _jsx(OriginatingUrl, { url: data.originating_url }, data.originating_url),
            ]);
        }
    }
    if (data.os_name) {
        items.push(['OS', data.os_name]);
    }
    if (data.browser_name) {
        items.push(['Browser Name', data.browser_name]);
    }
    if (data.browser_version) {
        items.push(['Browser Version', data.browser_version]);
    }
    if (items.length === 0) {
        // If there aren't any attributes to show, then don't render this card altogether
        return null;
    }
    const avatar = _jsx(Avatar, { icon: "map-pin" });
    if (isMinimized) {
        return _jsx("div", { children: avatar });
    }
    const lines = items.map(([label, value]) => (_jsx(CollapseCard.Line, Object.assign({ label: label }, { children: value }), label)));
    return (_jsxs(CollapseCard, Object.assign({ isOpen: isOpen, onToggle: (open) => {
            onToggle(open);
            setLocalIsOpen(open);
        } }, { children: [_jsx(CollapseCard.Header, Object.assign({ avatar: avatar, title: "Tracking" }, { children: "Tracking" })), _jsx(CollapseCard.Content, { children: lines })] })));
};
